import React from 'react';
import './Inventory.scss';
import { FormattedMessage } from 'react-intl';

const Inventory = (props) => {
  return (
    <div className="inventory-catalog-container">
      <div className="container">
        <h1 className="title-inventory">
          <FormattedMessage
            id="inventory.title"
            defaultMessage="Browse nearby inventory"
            description="Browse nearby inventory"
          />
        </h1>
        <h2 className="subtitle-inventory">
          <FormattedMessage
            id="inventory.subTitle"
            defaultMessage="Inventory from participating dealers."
          />
        </h2>
        <zr-vehicles-inventory-widget
          lang={props.language.toLowerCase() ?? 'en'}
        ></zr-vehicles-inventory-widget>
      </div>
    </div>
  );
};

export default Inventory;
